import type { AnyObject, Lazy, Schema } from 'yup';

import _ from '@luna/lodash';

import { type FormikErrors, type FormikValues } from './type';

export function validateSync<T extends FormikValues>(
    schema: Schema<FormikValues> | Lazy<AnyObject>,
    values: T,
    context: FormikValues = {},
): FormikErrors<T> {
    try {
        schema.validateSync(values, {
            abortEarly: false,
            context,
        });
    } catch (error: any) {
        if (error.name !== 'ValidationError') {
            throw error;
        }

        return error.inner.reduce(
            // @ts-expect-error no-implicit-any
            (errors, currentError) => _.set(errors, currentError.path, currentError.message),
            {},
        );
    }

    return {};
}
